import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UiInfoCard } from "../../_uiComponents/cards/UiInfoCard";
import {
    UiPointsItem,
    UiWishListItem,
} from "../../_uiComponents/cards/UiInfoCardContent";
import VoucherItem from "./VoucherItem";
import { shopFavouritesRequest } from "../../../_redux/_actions";

export const WishList = (props) => {
    const actionDispatch = useDispatch();

    const { favourites } = useSelector((state) => {
        return { favourites: state.shop.favourites };
    });

    useEffect(() => {
        actionDispatch(
            shopFavouritesRequest({
                pageNumber: 1,
                pageSize: 8,
                type: 0,
            }),
        );
    }, []);

    return (
        <>
            <UiInfoCard
                subtitle="My Favourites"
                contentTitle="Favourites"
                linkTitle="Browse All Favourites"
                LinkTo="/app/shop/browse-products"
                footer={true}
            >
                {favourites.vouchers.length > 0 ? (
                    <>
                        {favourites.vouchers
                            .filter((item, index) => index < 6)
                            .map((voucher, index) => {
                                return (
                                    <VoucherItem
                                        key={index}
                                        id={voucher.id}
                                        favouriteName={voucher.header}
                                    />
                                );
                            })}
                    </>
                ) : (
                    <UiWishListItem>
                        <h5>
                        You haven't added any items to your favourites list yet
                        </h5>

                       
                    </UiWishListItem>
                )}

                <hr />
            </UiInfoCard>
        </>
    );
};
